<!--企业查询-->
<template>
  <div class="enterprise-container">
    <header-index/>
    <div class="enterprise-content">
      <div class="enterprise-top">
        <p class="enterprise-title">企业信用查询</p>
        <el-input placeholder="请输入企业名称" v-model="keyword" class="input-with-select" style="width: 45%;" @keyup.enter.native="getEnterpriseInfo">
          <el-button type="danger" slot="append" @click="getEnterpriseInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="enterprise-menu">
        <div class="enterprise-hot">
          <p class="small-title">热门查询</p>
          <el-row :gutter="20" class="el-row-level">
            <el-col :span="4" class="el-col-small-menu">
              <div @click="enterpriseTagQuery('专精特新小巨人',5)">
                <p class="black-title">专精特新小巨人</p>
                <p class="grey-span">{{popularQueries.xjrCount}}家企业</p>
              </div>
            </el-col>
            <el-col :span="4" class="el-col-small-menu">
              <div @click="enterpriseTagQuery('高新技术企业',1)">
                <p class="black-title">高新技术企业</p>
                <p class="grey-span">{{popularQueries.gxjsCount}}家企业</p>
              </div>
            </el-col>
            <el-col :span="4" class="el-col-small-menu">
              <div @click="enterpriseTagQuery('企业技术中心',14)">
                <p class="black-title">企业技术中心</p>
                <p class="grey-span">{{popularQueries.qyjsCount}}家企业</p>
              </div>
            </el-col>
            <el-col :span="4" class="el-col-small-menu">
              <div @click="searchBidding">
                <p class="black-title">招投标</p>
                <p class="grey-span">{{popularQueries.ztbCount}}家企业</p>
              </div>
            </el-col>
            <el-col :span="4" class="el-col-small-menu">
              <div @click="enterpriseTagQuery('新增企业')">
                <p class="black-title">新增企业</p>
                <p class="grey-span">{{popularQueries.xzCount}}家企业</p>
              </div>
            </el-col>
            <el-col :span="4" class="el-col-small-menu" style="margin-right: 0px;">
              <div @click="enterpriseTagQuery('众创空间',7)">
                <p class="black-title">众创空间</p>
                <p class="grey-span">{{popularQueries.zckjCount}}家企业</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="enterprise-info">
          <el-row :gutter="16">
            <el-col :span="12">
              <div class="enterprise-major">
                <p class="small-title">重要信息</p>
                <el-row :gutter="20" class="el-row-level">
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="creditRating">
                      <i class="iconfont icon-beizhihangren"/>
                      <p class="black-title">税务评级</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="administrativeSanction">
                      <i class="iconfont icon-hangzhengchufa"/>
                      <p class="black-title">行政处罚</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="adjudicativeDocument">
                      <i class="iconfont icon-caipanwenshu"/>
                      <p class="black-title">裁判文书</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu" style="margin-right: 0px">
                    <div @click="holdCourtNotice">
                      <i class="iconfont icon-kaitinggonggao"/>
                      <p class="black-title">开庭公告</p>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="el-row-level">
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="executor">
                      <i class="iconfont icon-beizhihangren"/>
                      <p class="black-title">被执行人</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="courtNotice">
                      <i class="iconfont icon-fayuangonggao"/>
                      <p class="black-title">法院公告</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="impOrExpCredit">
                      <i class="iconfont icon-jinchukouxinyong"/>
                      <p class="black-title">进出口信用</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu" style="margin-right: 0px">
                    <div @click="judicialSale">
                      <i class="iconfont icon-sifapaimai"/>
                      <p class="black-title">司法拍卖</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="enterprise-base">
                <p class="small-title">企业信息库</p>
                <el-row :gutter="20" class="el-row-level">
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="infoBase('上市企业')">
                      <i class="iconfont icon-shangshiqiye"/>
                      <p class="black-title">上市企业</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="infoBase('融资事件')">
                      <i class="iconfont icon-rongzishijian"/>
                      <p class="black-title">融资事件</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="infoBase('产业链')">
                      <i class="iconfont icon-chanyelian"/>
                      <p class="black-title">产业链</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu" style="margin-right: 0px">
                    <div @click="infoBase('投资机构')">
                      <i class="iconfont icon-touzijigou"/>
                      <p class="black-title">投资机构</p>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="el-row-level">
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="infoBase('产业园区')">
                      <i class="iconfont icon-chanyeyuanqu"/>
                      <p class="black-title">产业园区</p>
                    </div>
                  </el-col>
                  <el-col :span="6" class="el-col-small-menu">
                    <div @click="infoBase('债券')">
                      <i class="iconfont icon-zhaiquan"/>
                      <p class="black-title">债券</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {pcPopularQueries} from '@/api/enterpriseDetailsApi'
export default {
  name: "index",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      keyword: '',
      cid: 0,
      pName: '',
      childNode: {},
      CustomInfo: {},
      popularQueries:{},
      locationInfo:{},
    }
  },
  methods: {
    /*开庭公告*/
    holdCourtNotice() {
      let routeData = this.$router.resolve({
        name: "courtNotice",
        path: '/enterpriseSearch/courtNotice',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*法院公告*/
    courtNotice() {
      let routeData = this.$router.resolve({
        name: "court",
        path: '/enterpriseSearch/court',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*招投标*/
    searchBidding() {
      let routeData = this.$router.resolve({
        name: "bidding",
        path: '/enterpriseSearch/bidding',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*被执行人*/
    executor() {
      let routeData = this.$router.resolve({
        name: "executor",
        path: '/enterpriseSearch/executor',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*被执行人*/
    creditRating() {
      let routeData = this.$router.resolve({
        name: "creditRating",
        path: '/enterpriseSearch/creditRating',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*行政处罚*/
    administrativeSanction() {
      let routeData = this.$router.resolve({
        name: "administrativeSanction",
        path: '/enterpriseSearch/administrativeSanction',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*裁判文书*/
    adjudicativeDocument() {
      let routeData = this.$router.resolve({
        name: "adjudicativeDocument",
        path: '/enterpriseSearch/adjudicativeDocument',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*进出口信用*/
    impOrExpCredit() {
      let routeData = this.$router.resolve({
        name: "impOrExpCredit",
        path: '/enterpriseSearch/impOrExpCredit',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*司法拍卖*/
    judicialSale() {
      let routeData = this.$router.resolve({
        name: "judicialSale",
        path: '/enterpriseSearch/judicialSale',
        query: {pName: this.pName}
      });
      window.open(routeData.href, '_blank')
    },
    /*企业信息库*/
    infoBase(name) {
      let routeData = this.$router.resolve({
        name: "infoBase",
        path: '/enterpriseSearch/infoBase',
        query: {pName: this.pName, name: name}
      });
      window.open(routeData.href, '_blank')
    },
    /*企业标签查询*/
    enterpriseTagQuery(type,id) {
      let routeData = this.$router.resolve({
        name: "enterpriseTagQuery",
        path: '/enterpriseSearch/enterpriseTagQuery',
        query: {pName: this.pName, searchType: type,enterpriseType:id}
      });
      window.open(routeData.href, '_blank')
    },
    /*企业查询-关键字*/
    getEnterpriseInfo(){
      let routeData = this.$router.resolve({
        name: "enterpriseTagQuery",
        path: '/enterpriseSearch/enterpriseTagQuery',
        query: {pName: this.pName, keyword: this.keyword,searchType:'企业名称查询'}
      });
      window.open(routeData.href, '_blank')
    },
    getPopularQueries(){
      pcPopularQueries({cityCode:this.locationInfo.id}).then(res=>{
        if (res.code==200){
          console.log(res.content);
          this.popularQueries=res.content;
        }
      })
    }
  },
  mounted() {
    this.getPopularQueries();
  },
  beforeMount() {
    this.locationInfo=JSON.parse(sessionStorage.getItem('locationInfo'));
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.CustomInfo = JSON.parse(sessionStorage.getItem('CustomInfo'));
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
.enterprise-container >>> .enterprise-content .enterprise-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.enterprise-container >>> .enterprise-content .enterprise-top input::-webkit-input-placeholder {
  color: #333333;
}

.enterprise-container >>> .enterprise-content .enterprise-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.enterprise-container >>> .enterprise-content .enterprise-top .el-icon-search {
  font-size: 19px;
}

.enterprise-container >>> .enterprise-content .enterprise-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}
</style>
<style scoped lang="scss">
.enterprise-container {
  background: #E7E9F5;

  .enterprise-content {
    .enterprise-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 400px;
      min-width:76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .enterprise-title {
        color: #ffffff;
        margin: 100px 0 60px;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 100px 0px 60px;
        font-weight: bold;
      }
    }

    .enterprise-menu {
      padding: 0px 18% 30px;
      min-width: 76rem;

      .small-title {
        margin-block-end: 0px;
        margin-block-start: 0px;
        font-size: 16px;
        padding-bottom: 5px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        border-bottom: 1px solid #E7E9F5;
        cursor: pointer;
      }

      .enterprise-hot {
        background: #FFFFFF;
        padding: 20px;
        margin-top: -50px;

        .el-row-level {
          margin-top: 20px;
          margin-left: 0px !important;
          margin-right: 0px !important;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .el-col-small-menu {
            background: #F6F7FF;
            padding-bottom: 20px;
            padding-top: 20px;
            margin-right: 10px;
            //width: 15%;
            padding-left: 20px !important;
            padding-right: 0px !important;
            cursor: pointer;

            .black-title {
              font-size: 16px;
              font-family: 'SourceHanSansCN';
              color: #333333;
              margin-block-start: 0px;
              margin-block-end: 0px;
            }

            .grey-span {
              font-size: 14px;
              font-family: 'SourceHanSansCN';
              font-weight: 500;
              color: #999999;
              margin-block-start: 0px;
              margin-block-end: 0px;
            }
          }
        }
      }

      .enterprise-info {
        margin-top: 20px;

        .el-row-level {
          margin-top: 20px;
          margin-left: 0px !important;
          margin-right: 0px !important;

          .el-col-small-menu {
            background: #F6F7FF;
            text-align: center;
            padding-top: 20px;
            padding-left: 20px !important;
            padding-right: 20px !important;
            padding-bottom: 20px;
            padding-top: 20px;
            margin-right: 15px;
            width: 22.4%;

            .iconfont {
              color: #fe273b;
              font-size: 40px;
            }

            .black-title {
              font-size: 14px;
              padding-top: 10px;
              font-family: 'SourceHanSansCN';
              color: #333333;
              margin-block-start: 0px;
              margin-block-end: 0px;
            }
          }
        }

        .enterprise-major {
          background: #FFFFFF;
          padding: 20px;
        }

        .enterprise-base {
          background: #FFFFFF;
          padding: 20px;
        }
      }
    }
  }
}
</style>